package com.appsyde.shared.modules.ticket.domain

class AssignConflictException(
    val assignedToAccountUserId: String,
    val assignedToDisplayName: String,
    message: String? = "Ticket already assigned to another user",
    cause: Throwable? = null
) : Exception(message, cause)
